import { render, staticRenderFns } from "./DialogPendenciarDados.vue?vue&type=template&id=7fc44612&scoped=true&"
import script from "./DialogPendenciarDados.vue?vue&type=script&lang=js&"
export * from "./DialogPendenciarDados.vue?vue&type=script&lang=js&"
import style0 from "./DialogPendenciarDados.vue?vue&type=style&index=0&id=7fc44612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc44612",
  null
  
)

export default component.exports